import { registerSW } from "virtual:pwa-register";

let registered = false;

export function setupAppSW() {
  if (registered) return;
  registered = true;

  registerSW({
    immediate: true,
    onRegisterError(error) {
      console.error("App SW registration failed", error);
    },
  });
}
